import { GET, PATCH, POST } from '@/lib/api/Methods';
import {
   CreateIntentPayload,
   CreateIntentResponse,
   StartAutoRenewalPayload,
   PaySubscriptionPayload,
   zeroPaymentpayload,
} from './payment.types';
import { Package, Product } from '@/core/models';

export const createPaymentIntent = async (data: CreateIntentPayload) =>
   POST<CreateIntentPayload, CreateIntentResponse>('/payment/create-payment-intent', data);

export const getProductPrice = async () => GET<never, Product>('/payment/get-price');

export const getSubscriptionPrice = async (id: string) => GET<never, Product>(`/payment/package-price/${id}`);

export const startAutoRenewal = async (data: StartAutoRenewalPayload) =>
   POST<StartAutoRenewalPayload, CreateIntentResponse>('/payment/pay-subscription', data);

export const getClinicPartnerSubscriptionPackages = () => GET<never, Package[]>('/package/package-list');

export const paySubscription = async (data: PaySubscriptionPayload) =>
   POST<PaySubscriptionPayload, unknown>('/payment/pay-subscription', data);

export const getPackage = (packageId: string) => GET<never, Package>(`/package/details/${packageId}`);

export const updateWithZeroPayment = async (userId: string, payload: zeroPaymentpayload) =>
   PATCH<unknown, unknown>(`/payment/update-users-with-zero-payment/${userId}`, payload);
